import ('./style.scss')

import ReportsList from './reports-list'

export default ReportsList
